let routes = [
  {
    path: '/address-complete',
    component: () => import('../views/AddressComplete.vue'),
  }

]

export default routes;